export default __webpack_public_path__ + "static/media/37.644fb50c.jpg";